import axios from 'axios';
import Cookies from 'js-cookie';

export const AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://hellocer-backend.onrender.com/api',
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${Cookies.get('accessToken') || ''}`
  }
});

// request interceptor to add access token
AxiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get("accessToken");
    if (token) {
      AxiosInstance.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle token refresh
AxiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // If 401 error and not already retried
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url.includes('/auth/login') &&
      !originalRequest.url.includes('/auth/register')
    ) {
      originalRequest._retry = true;
      
      try {
        // request new access token
        const refreshToken = Cookies.get("refreshToken");
        const apiBaseUrl = process.env.REACT_APP_API_URL || AxiosInstance.defaults.baseURL.split('/api')[0];
        const res = await axios.post(
          `${apiBaseUrl}/api/auth/refresh-token`,
          { refreshToken }
        );

        const { accessToken } = res.data;
        // update local storage and Axios headers
        Cookies.set("accessToken", accessToken, { secure: true, sameSite: 'strict' });
        originalRequest.headers["Authorization"] = `Bearer ${accessToken}`;
        
        // Retry the original request
        return AxiosInstance(originalRequest);
      } catch (refreshError) {
        // If refresh fails, clear store and redirect
        Cookies.remove("accessToken");
        Cookies.remove("refreshToken");
        Cookies.remove("role");
        Cookies.remove("user");
        window.location.href = "/clients/signin";
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);